<template>
  <section class="mt-16">
      <v-breadcrumbs
        large
        :items="crumbs"
        divider="/"
        class="pl-0"
      ></v-breadcrumbs>

      <h1 class="primary--text">
        <v-icon color="primary">mdi-shield-account</v-icon> <span>Registo de Role</span>
      </h1>

      <div class="mt-16">
        <role method="create"></role>
      </div>
  </section>
</template>
<script>
import Role from '@/components/roles/Role'

export default {
  components: {
    Role
  },
  beforeCreate(){
    document.title = "Hefesto - Registo de Roles";
  },
  data: () => ({
    
  }),
  mounted(){

    if(!this.$root.session.hasPermission(["super", "roles.create"])) {
      this.$router.push('/admin');
    }

  },
  methods:{
  },
  computed: {
    crumbs: function() {
      return [
        {
          text: 'Dashboard',
          disabled: false,
          to: '/admin',
          exact: true,
        },
        {
          text: 'Gestão Roles',
          disabled: false,
          to: '/admin/settings/roles',
          exact: true,
        },
        {
          text: 'Registo de Role',
          disabled: true,
          to: window.location.href,
          exact: true,
        },
      ];
    }
  }
};
</script>
